export default __webpack_public_path__ + "static/ay-support-hero-main-image-d75d772c61727575f1885797ed11831c.svg";